module.exports = __webpack_public_path__ + "static/img/logo2.8c2d8fce.png";